interface HoneypotProps {
  name?: string;
}

export default function Honeypot({ name = "website_alt" }: HoneypotProps) {
  return (
    <input
      type="text"
      name={name}
      className="field-extra-note"
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      readOnly
    />
  );
}